import { getSpan, listDeltas, listSpans } from "./endpoints";

export { service } from "./endpoints";
export { GameSpan, GameSpansQuery, GameSpansResponse } from "./schemas";

export const contract = {
  games: {
    deltas: { list: listDeltas },
    spans: { list: listSpans, get: getSpan },
  },
} as const;
